import PortalVue from 'portal-vue'


export const initPlugin = ({ Vue }) => {
  Vue.use(PortalVue)
}
